<template>
  <tr>
    <th></th>
    <th></th>
    <th></th>
    <th class="text-center">
      <div><b>Total Paid Commission</b></div>
    </th>
    <th></th>
    <th></th>
    <td class="text-center">
      <div>
        {{ totalCommissionPaid + " ฿" }}
      </div>
    </td>
    <th></th>
    <th></th>
  </tr>
</template>

<script>
export default {
  name: "commissionPaid",
  props: ["totalCommissionPaid"],
};
</script>

<style>
</style>